<template>
  <nav
    class="navbar navbar-expand bg-dark shadow"
    style="padding-bottom: var(--safe-area-inset-bottom)"
  >
    <div class="container-fluid">
      <div class="navbar-nav d-flex justify-content-evenly w-100">
        <NuxtLink
          class="nav-item nav-link d-flex flex-column align-items-center p-0"
          :to="{ path: '/journey-search-result', hash: '#search' }"
          ><i class="icon icon-search fs-4"></i>
          <div>Suche</div></NuxtLink
        >
        <NuxtLink
          class="nav-item nav-link d-flex flex-column align-items-center p-0"
          :to="{ path: '/saved-journeys', hash: '#content' }"
          ><i class="icon icon-bookmark-fill fs-4"></i>
          <div>Gemerkt</div></NuxtLink
        >
      </div>
    </div>
  </nav>
</template>
